// removed by extract-text-webpack-plugin
module.exports = {"listHeader":"_1PURU3hMIrPhny2WmO2LzL","indexField":"_1LqRgH9lHAIaxdCnouGxQz","descriptionField":"_1CZyDEzTES1cYYCZA0ImWp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AgentInfo/components/CharLists/style.css
// module id = 391
// module chunks = 0